import { computed } from "vue";
import {} from "@/components/ObjectStore/Templates/types";
import { useObjectStoreInstancesStore } from "@/stores/objectStoreInstancesStore";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import {} from "./types";
export function useInstanceAndTemplate(instanceIdRef) {
    const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
    const objectStoreInstancesStore = useObjectStoreInstancesStore();
    objectStoreInstancesStore.fetchInstances();
    objectStoreTemplatesStore.fetchTemplates();
    const instance = computed(() => objectStoreInstancesStore.getInstance(instanceIdRef.value) || null);
    const template = computed(() => {
        var _a, _b;
        return instance.value
            ? objectStoreTemplatesStore.getTemplate((_a = instance.value) === null || _a === void 0 ? void 0 : _a.template_id, (_b = instance.value) === null || _b === void 0 ? void 0 : _b.template_version)
            : null;
    });
    return { instance, template };
}
